import { createApiSlice } from "@common";
import {
  CRUD_LEAD_QUALIFICATION,
  GET_LEAD_QUALIFICATION_BY_LEAD_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addLeadQualification",
    method: "post",
    url: CRUD_LEAD_QUALIFICATION,
    stateKey: "message",
  },
  {
    name: "getLeadQualificationByLeadId",
    method: "get",
    url: GET_LEAD_QUALIFICATION_BY_LEAD_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "leadQualification",
  apiConfig,
  customReducers
);
const leadQualificationSlice = slice;

export default leadQualificationSlice.reducer;

export const {
  addLeadQualification,
  getLeadQualificationByLeadId,
} = thunks;

export const { rowSelect } = actions;
